class LiveChat {
    constructor() {
        this.chatLink = document.getElementById('chat_link');
        this.retryCount = 0;
        this.maxRetries = 10; // Massimo 10 tentativi (5 secondi totali)

        if (this.chatLink) {
            this.init();
        }
    }

    init() {
        this.chatLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.retryCount = 0; // Reset del contatore ad ogni click
            this.handleChatClick();
        });
    }

    handleChatClick() {
        // Prima controlla se c'è il link WhatsApp visibile
        const wappLink = document.getElementById('to_wapp');
        if (wappLink && wappLink.offsetParent !== null) {
            wappLink.click();
            return;
        }

        // Cerca l'elemento livechat-wrapper (potrebbe essere caricato dinamicamente)
        // Prova prima con getElementById
        let chatWrapper = document.getElementById('livechat-wrapper');

        // Se non trovato, prova a cercare l'elemento custom chat-oct8ne
        if (!chatWrapper) {
            chatWrapper = document.querySelector('chat-oct8ne#livechat-wrapper');
        }

        if (chatWrapper) {
            // Prova diversi metodi per aprire la chat
            // Metodo 1: click diretto
            if (typeof chatWrapper.click === 'function') {
                chatWrapper.click();
            }
            // Metodo 2: dispatch event click
            else {
                const clickEvent = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                });
                chatWrapper.dispatchEvent(clickEvent);
            }

            // Metodo 3: se è un elemento custom, prova a chiamare un metodo specifico
            if (chatWrapper.tagName === 'CHAT-OCT8NE' && typeof chatWrapper.openChat === 'function') {
                chatWrapper.openChat();
            }
        } else {
            // Se l'elemento non è ancora presente, aspetta un po' e riprova
            if (this.retryCount < this.maxRetries) {
                this.retryCount++;
                setTimeout(() => {
                    this.handleChatClick();
                }, 500);
            } else {
                console.warn('LiveChat: Impossibile trovare l\'elemento livechat-wrapper dopo ' + this.maxRetries + ' tentativi');
            }
        }
    }
}

// Inizializza la classe LiveChat
document.addEventListener('DOMContentLoaded', () => {
    new LiveChat();
});

